const rankingItems = [
  { rank: 1, title: '国产高清视频精选合集', heat: '203.7万', trend: 'up', change: '+12%' },
  { rank: 2, title: '超清画质影视在线专区', heat: '167.2万', trend: 'up', change: '+8%' },
  { rank: 3, title: '91高清在线每日更新', heat: '128.6万', trend: 'up', change: '+15%' },
  { rank: 4, title: '热门视频周榜推荐', heat: '96.3万', trend: 'stable', change: '持平' },
  { rank: 5, title: '移动端观影热门精选', heat: '72.5万', trend: 'up', change: '+5%' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            91高清视频在线热门内容排行榜，看看大家都在看什么
          </p>
        </div>
        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer transition-colors hover:bg-background-100 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-accent-500 text-white'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                <span className="text-sm font-heading font-bold">{item.rank}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-900 truncate">
                  {item.title}
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1"></i>
                    {item.heat}
                  </span>
                </div>
              </div>
              <div className={`flex items-center gap-1 text-xs flex-shrink-0 ${
                item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {item.trend === 'up' ? (
                  <i className="ri-arrow-up-line"></i>
                ) : (
                  <i className="ri-subtract-line"></i>
                )}
                <span className="font-medium">{item.change}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}